import { Pipe, PipeTransform } from '@angular/core';

import { ContactType } from '../models';
import { ClaimsService } from '@core/authentication/claims.service';
import { Claims } from '@core/authentication/claims';
import { aggregator } from '@env/aggregator/aggregator';
import { Aggregator } from '@liberty-financial/agp-shared';

@Pipe({
  name: 'displayAffiliateId'
})
export class DisplayAffiliateId implements PipeTransform {
  constructor(private claimService: ClaimsService) {}

  transform(contactType: ContactType | null): boolean {
    return (
      contactType === ContactType.Referrer &&
      this.claimService.userRole === Claims.UserRoles.NetworkAdministrator &&
      aggregator.name !== Aggregator.MPM
    );
  }
}
